import * as types from '../constants/ActionTypes'

const initalState = {
  list: [],
  form: {},
  page: 1,
  selectData: {},


  tmpPage: 1,
  tmpForm: {},
  summaryCsv: null,
  summaryCsvOpen: false,
}


const master = (state = initalState, action) => {
  
  switch (action.type) {
    case types.REDUCER_YOSANLIST_INIT:
    case types.REDUCER_YOSANLIST_SET_SEARCH_RESULT:
    case types.REDUCER_SUMMARYCSV_RESULT:
    case types.REDUCER_SUMMARYCSV_CLOSE:
    case types.REDUCER_YOSANLIST_FORM_CLEAR:
      return Object.assign({}, state, action.payload)
    default:
      return state
  }
}

export default master


// WEBPACK FOOTER //
// ./src/reducers/yosanList.js